import { render, staticRenderFns } from "./ProfileModalBody.vue?vue&type=template&id=7577d4ea&scoped=true"
import script from "./ProfileModalBody.vue?vue&type=script&lang=js"
export * from "./ProfileModalBody.vue?vue&type=script&lang=js"
import style0 from "./ProfileModalBody.vue?vue&type=style&index=0&id=7577d4ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7577d4ea",
  null
  
)

export default component.exports